import Vue from "vue";
import Router from "vue-router";
import { publicPath } from "../../vue.config";
import { store } from "../store/store";

import Home from "../views/Home.vue";
import Auth from "../views/auth/Auth.vue";
import Event from "../views/Event.vue";
import EventCheckout from "../views/EventCheckout.vue";
import Redirect from "../views/auth/Redirect.vue";
import MisTickets from "../views/MisTickets.vue";
import Eventos from "../views/Eventos.vue";
import EventSuccess from "../views/EventSuccess.vue";
import EventSuccessPayment from "../views/EventSuccessPayment.vue";
import EventFailedPayment from "../views/EventFailedPayment.vue";
import Contacto from "../views/Contacto.vue";
import TerminosYCondiciones from "../views/legal/TerminosYCondiciones.vue";
import PoliticaDePrivacidad from "../views/legal/PoliticaDePrivacidad.vue";
import Faq from "../views/legal/Faq.vue";
import CategoriaVidaNocturna from "../views/categorias/CategoriaVidaNocturna.vue";
import CategoriaFutbol from "../views/categorias/CategoriaFutbol.vue";
import CategoriaBasquetbol from "../views/categorias/CategoriaBasquetbol.vue";
import CategoriaOtros from "../views/categorias/CategoriaOtros.vue";
import Cortesia from '../views/Cortesia.vue';
import LinkPago from '../views/LinkPago.vue';
import PageNotFound from '../views/PageNotFound.vue';
import Error from '../views/Error.vue';

import OrganizadorDashboard from "../views/organizador/OrganizadorDashboard.vue";

Vue.use(Router);

// https://github.com/sqreen/vue-authentication-example/blob/master/src/main.js

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.AuthModule.loggedIn) {
    next();
    window.scrollTo(0, 0);
    return;
  }
  next({ name: "home" });
};

const ifAuthenticated = (to, from, next) => {
  if (store.state.AuthModule.loggedIn) {
    next();
    window.scrollTo(0, 0);
    return;
  }

  store.dispatch("AuthModule/updateCallbackAction", {
    callbackAction: {
      name: "AuthModule/redirigirA",
      payload: {
        route: to.name,
        params: to.params,
      },
    },
  });

  next({ name: "login" });
};

const router = new Router({
  mode: "history",
  base: publicPath,
  routes: [
    {
      path: "",
      name: "home",
      component: Home,
      props: true,
    },
    {
      path: "/login",
      name: "login",
      component: Auth,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    {
      path: "/register",
      name: "register",
      component: Auth,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    {
      path: "/verify-email/:preUsuarioId",
      name: "verify-email",
      component: Auth,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    {
      path: "/forgot-password",
      name: "forgot-password-request",
      component: Auth,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    {
      path: "/restore-password/:hash",
      name: "forgot-password",
      component: Auth,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    // {
    // 	path: "/profile",
    // 	name: "profile",
    // 	component: () => import("../views/Profile.vue"),
    // 	beforeEnter: ifAuthenticated,
    // 	// component: Profile
    // },
    {
      path: "/cuenta",
      name: "cuenta",
      component: () => import("../views/cuenta/Cuenta.vue"),
      beforeEnter: ifAuthenticated,
      meta: {
        whiteBg: true,
      },
      children: [
        {
          path: "informacion-personal",
          name: "informacion-personal",
          components: {
            cuenta: () => import("../views/cuenta/InformacionPersonal.vue"),
          },
          meta: {
            whiteBg: true,
          },
        },

        {
          path: "seguridad",
          name: "notificaciones-seguridad",
          components: {
            cuenta: () => import("../views/cuenta/NotificacionesSeguridad.vue"),
          },
          meta: {
            whiteBg: true,
          },
        },

        {
          path: "mis-amigos",
          name: "mis-amigos",
          components: {
            cuenta: () => import("../views/cuenta/MisAmigos.vue"),
          },
          meta: {
            whiteBg: true,
          },
        },
      ],
    },
    {
      path: "/eventos",
      name: "eventos",
      component: Eventos,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/contacto",
      name: "contacto",
      component: Contacto,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/redirect",
      name: "redirect",
      component: Redirect,
      beforeEnter: ifNotAuthenticated,
      meta: {
        hideHeaderFooter: true,
      },
    },
    {
      path: "/preview/:eventSlug/:eventId",
      name: "evento-preview",
      component: Event,
      meta: {
        isEventPreview: true
      }
    },
    // {
    //   path: "/evento/:eventSlug/:eventId/checkout",
    //   name: "evento-checkout",
    //   component: EventCheckout,
    //   beforeEnter: ifAuthenticated,
    //   meta: {
    //     whiteBg: true,
    //   },
    // },
	{
		path: "/checkout/:transaccionId",
		name: "evento-checkout",
		component: EventCheckout,
		// beforeEnter: ifAuthenticated,
		meta: {
		  whiteBg: true,
		},
	  },
    {
      path: "/evento/:eventSlug/:eventId/:promotorCodigo?",
      name: "evento",
      component: Event,
    },
    {
      path: "/pago-exitoso",
      name: "pago-exitoso",
      component: EventSuccessPayment,
      meta: {
        whiteBg: true,
      }
    },
    {
      path: "/pago-fallido",
      name: "pago-fallido",
      component: EventFailedPayment,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/canje-exitoso/:eventId",
      name: "canje-exitoso",
      component: EventSuccess,
      meta: {
        whiteBg: true,
      },
      props: true
    },
    {
      path: "/mis-tickets",
      name: "mis-tickets",
      component: MisTickets,
      beforeEnter: ifAuthenticated,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/terminos-y-condiciones",
      name: "terminos-y-condiciones",
      component: TerminosYCondiciones,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/politica-de-privacidad",
      name: "politica-de-privacidad",
      component: PoliticaDePrivacidad,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/preguntas-frecuentes",
      name: "faq",
      component: Faq,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: "/organizador",
      name: "organizador-dashboard",
      component: OrganizadorDashboard,
      meta: {
        whiteBg: true,
      },
      beforeEnter: ifAuthenticated,
      redirect: { name: 'organizador-eventos' },
      children: [
        {
          path: 'eventos',
          name: 'organizador-eventos',
          components: {
            organizador: () => import('../views/organizador/OrganizadorEventos.vue')
          },
          meta: {
            whiteBg: true
          },
          children: [
            {
              path: "evento/:eventoId",
              name: "organizador-evento",
              components: {
                organizadoreventos: () => import("../views/organizador/OrganizadorEvento.vue"),
              },
              meta: {
                whiteBg: true,
              },
              redirect: { name: 'organizador-evento-estadisticas' },
              children: [
                {
                  path: "estadisticas",
                  name: "organizador-evento-estadisticas",
                  components: {
                    organizadorevento: () => import("../components/organizador-evento/OrganizadorEventoEstadisticas.vue"),
                  },
                  meta: {
                    whiteBg: true,
                  }
                },
                {
                  path: "tickets",
                  name: "organizador-evento-tickets",
                  components: {
                    organizadorevento: () => import("../components/organizador-evento/OrganizadorEventoTickets.vue"),
                  },
                  meta: {
                    whiteBg: true,
                  }
                },
                {
                  path: "cortesias",
                  name: "organizador-evento-cortesias",
                  components: {
                    organizadorevento: () => import("../components/organizador-evento/OrganizadorEventoCortesias.vue"),
                  },
                  meta: {
                    whiteBg: true,
                  }
                },
                {
                  path: "promotores",
                  name: "organizador-evento-promotores",
                  components: {
                    organizadorevento: () => import("../components/organizador-evento/OrganizadorEventoPromotores.vue"),
                  },
                  meta: {
                    whiteBg: true,
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'mi-organizacion',
          name: 'organizador-mi-organizacion',
          components: {
            organizador: () => import('../views/organizador/OrganizadorMiOrganizacion.vue')
          },
          meta: {
            whiteBg: true
          }
        },
        {
          path: 'usuarios',
          name: 'organizador-usuarios',
          components: {
            organizador: () => import('../views/organizador/OrganizadorUsuarios.vue')
          },
          meta: {
            whiteBg: true
          }
        },
        {
          path: 'segmentos',
          name: 'organizador-segmentos',
          components: {
            organizador: () => import('../views/organizador/OrganizadorSegmentos.vue')
          },
          meta: {
            whiteBg: true
          }
        },
        {
          path: 'productos',
          name: 'organizador-productos',
          components: {
            organizador: () => import('../views/organizador/OrganizadorProductos.vue')
          },
          meta: {
            whiteBg: true
          }
        }
        // {
        //   path: "evento/:eventoId",
        //   name: "organizador-evento",
        //   components: {
        //     organizador: () =>
        //       import("../views/organizador/OrganizadorEvento.vue"),
        //   },
        //   meta: {
        //     whiteBg: true,
        //   },
        // },
      ],
    },
    {
      path: "/categoria/vida-nocturna",
      name: "categoria-vida-nocturna",
      component: CategoriaVidaNocturna,
    },
    {
      path: "/categoria/futbol",
      name: "categoria-futbol",
      component: CategoriaFutbol,
    },
    {
      path: "/categoria/basquetbol",
      name: "categoria-basquetbol",
      component: CategoriaBasquetbol,
    },
    {
      path: "/categoria/otros",
      name: "categoria-otros",
      component: CategoriaOtros,
    },
    {
      path: '/cortesia/:eventSlug/:eventId/:cortesiaId/:cortesiaToken',
      name: 'cortesia',
      component: Cortesia,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: '/link-de-pago/:eventSlug/:eventId/:linkPagoId/:linkPagoToken',
      name: 'link-de-pago',
      component: LinkPago,
      meta: {
        whiteBg: true,
      },
    },
    {
      path: '/404',
      name: 'error',
      component: Error,
      meta: {
        whiteBg: true,
        hideFooter: true,
      },
    },
    {
      path: "*",
      component: PageNotFound,
      meta: {
        whiteBg: true,
        hideFooter: true,
      },
    }
  ],
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;
